// extracted by mini-css-extract-plugin
export default {"header":"headerDashboard_header__KyJVE","logo":"headerDashboard_logo__teTSG","logoOut":"headerDashboard_logoOut__zt4yo","anchorActive":"headerDashboard_anchorActive__thtcO"};